import OTPVerification from "./OTPVerification";

const LoginOTP = () => {
  return (
    <OTPVerification
      buttonText="Submit"
      redirectPath="/"
    />
  );
};

export default LoginOTP;